import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { User } from 'models/User';

import { useStorage } from 'hooks/useStorage';

import { parseJwt } from 'utils/parseJwt';

export const authTokenStorageKey = 'token';

export const useAuthentication = () => {
  const {
    query: { auth_access_token },
    isReady,
  } = useRouter();

  const { get, set } = useStorage();

  const loadToken = () => {
    const parsedJwt = parseJwt<User>(JSON.stringify(auth_access_token));

    if (parsedJwt) {
      set(authTokenStorageKey, auth_access_token);
    }
  };

  const userData = () => {
    if (typeof window === 'undefined') return;

    const authToken = get(authTokenStorageKey);

    return parseJwt<User>(authToken);
  };

  const tokenIsValid = () => {
    loadToken();

    const user = userData();

    if (!user) return false;

    const currentTimeInSeconds = Date.now() / 1000;

    return user.exp > currentTimeInSeconds;
  };

  useEffect(() => {
    if (!isReady || !auth_access_token) return;

    loadToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady, auth_access_token]);

  return {
    tokenIsValid,
    userData,
  };
};
